'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { usePreferenceList } from '@/modules/preferences/queries';

export const ThemeSync = () => {
  const { data: preferences } = usePreferenceList();
  const { setTheme } = useTheme();

  useEffect(() => {
    const dbTheme = preferences?.theme;

    if (dbTheme) {
      setTheme(dbTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preferences?.theme]);

  return null;
};
